import type { StoryItem, User, UserStories } from '@andresot/protocol';
import type { StoryCreate } from '@andresot/protocol/stories';
import { request } from './client.js';

export async function fetchStories(): Promise<{
	stories: UserStories[];
	hiddenAuthorIds: string[];
}> {
	return request<{ stories: UserStories[]; hiddenAuthorIds: string[] }>('/api/stories');
}

export async function hideStoryAuthor(userId: string): Promise<void> {
	await request<void>('/api/stories/hidden', { body: { userId } });
}

export async function showStoryAuthor(userId: string): Promise<void> {
	await request<void>(`/api/stories/hidden/${encodeURIComponent(userId)}`, { method: 'DELETE' });
}

export async function createStory(input: StoryCreate): Promise<StoryItem> {
	return (await request<{ story: StoryItem }>('/api/stories', { body: input })).story;
}

export async function viewStory(storyId: string): Promise<StoryItem> {
	return (
		await request<{ story: StoryItem }>(`/api/stories/${encodeURIComponent(storyId)}/view`, {
			body: {}
		})
	).story;
}

export async function deleteStory(storyId: string): Promise<void> {
	await request<void>(`/api/stories/${encodeURIComponent(storyId)}`, { method: 'DELETE' });
}

export async function fetchStoryViewers(storyId: string): Promise<User[]> {
	return (await request<{ viewers: User[] }>(`/api/stories/${encodeURIComponent(storyId)}/viewers`))
		.viewers;
}
